import { useEffect, useState } from 'react';
import { CheckCircle2, ChevronRight, FlaskConical, X } from 'lucide-react';
import { api } from '../lib/api';

type BetaState={
  betaMode:boolean;
  steps:Array<{id:string;label:string;complete:boolean}>;
  completed:number;
  total:number;
  dismissed:boolean;
  sampleProjectId?:string|null;
  openFeedback:number;
  recoveryOpen:number;
};

export default function BetaOnboarding({
  onSampleCreated,
}:{
  onSampleCreated:(project:unknown)=>void;
}){
  const[state,setState]=useState<BetaState|null>(null);
  const[busy,setBusy]=useState(false);
  const[message,setMessage]=useState('');
  const load=async()=>setState((await api.get<BetaState>('/api/beta/me')).data);
  useEffect(()=>{load().catch(()=>{});},[]);
  if(!state||state.dismissed||state.completed===state.total)return null;

  return <section className="card p-6 mb-6">
    <div className="row items-start">
      <div><span className="eyebrow">CREATOR ONBOARDING</span><h2>First-book activation.</h2><p className="muted">{state.completed}/{state.total} production milestones complete.</p></div>
      <button className="iconButton" onClick={async()=>{await api.put('/api/beta/onboarding',{dismissed:true});setState({...state,dismissed:true})}}><X size={16}/></button>
    </div>
    <div className="h-2 rounded bg-black/10 overflow-hidden mt-4"><div className="h-full bg-[#ef5b3e]" style={{width:`${Math.round(state.completed/state.total*100)}%`}}/></div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-2 mt-4">{state.steps.map(step=><div className="softBox" key={step.id}><div className="flex gap-2 items-center">{step.complete?<CheckCircle2 size={16}/>:<span className="w-4 h-4 rounded-full border border-black/20"/>}<b className="text-sm">{step.label}</b></div></div>)}</div>
    <div className="row mt-5">
      <p className="muted text-sm">Use your own story, import a script, or open the sample project to learn the production flow without starting from a blank canvas.</p>
      <button className="secondary shrink-0" disabled={busy} onClick={async()=>{setBusy(true);setMessage('');try{const{data}=await api.post('/api/beta/sample-project');onSampleCreated(data);await load()}catch(e){setMessage(e instanceof Error?e.message:'Sample project could not be created.')}finally{setBusy(false)}}}><FlaskConical size={15}/>{state.sampleProjectId?'Open/create sample':'Create sample project'}<ChevronRight size={14}/></button>
    </div>
    {message&&<div className="errorBox mt-3">{message}</div>}
  </section>
}
